import '../../verification/style.css';

const GuestTokenError = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='error-response'>
    <p>Something Went Wrong!</p>
    <div className='description'>
    We've encountered an issue. <br></br>
    Please try refreshing the page or try again after sometime. 
    </div>
    </div>
            </div>
            </div>
    </div>
    )
};

export default GuestTokenError;